import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveLayout',
  props: {
  alignItems: {
    type: String as PropType<'align-items-center' | 'align-items-start' | 'align-items-end' | 'align-items-baseline' | 'align-items-stretch'>,
    default: 'align-items-center',
  },
  justify: {
    type: String as PropType<'start' | 'end' | 'center' | 'space-between', 'space-around' | 'space-evenly'>,
    default: 'start',
  },
  marginY: {
    type: String as PropType<'my-0' | 'my-1' | 'my-2' | 'my-3' | 'my-4' | 'my-5'>,
    default: 'my-4',
  },
  width: {
    type: Number as PropType<number>,
    default: 100,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: `${__props.width}%` }),
    class: _normalizeClass([__props.marginY])
  }, [
    _createVNode(_component_el_row, {
      gutter: 10,
      class: _normalizeClass(__props.alignItems),
      justify: __props.justify
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          class: "py-2 py-md-1",
          xs: 24,
          sm: 8,
          md: 6,
          lg: 4,
          xl: 3
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "col-1")
          ]),
          _: 3
        }),
        _createVNode(_component_el_col, {
          class: "py-2 py-md-1",
          xs: 24,
          sm: 16,
          md: 6,
          lg: 8,
          xl: 9
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "col-2")
          ]),
          _: 3
        }),
        _createVNode(_component_el_col, {
          class: "py-2 py-md-1",
          xs: 24,
          sm: 8,
          md: 6,
          lg: 4,
          xl: 3
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "col-3")
          ]),
          _: 3
        }),
        _createVNode(_component_el_col, {
          class: "py-2 py-md-1",
          xs: 24,
          sm: 16,
          md: 6,
          lg: 8,
          xl: 9
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "col-4")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class", "justify"])
  ], 6))
}
}

})